import { render, staticRenderFns } from "./HighChart.vue?vue&type=template&id=667063d7&"
import script from "./HighChart.vue?vue&type=script&lang=js&"
export * from "./HighChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports